import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

import type { ApiDataHookUpdateHandler } from 'lib/api/useApiData';

interface Props {
  updateCourse: () => Promise<void>;
  updateUsers: ApiDataHookUpdateHandler;
}

const ShareUsersRemoveAll = ({ updateCourse, updateUsers }: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const remove = async () => {
    const response = await api.delete(`/admin/courses/${course.id}/users`);
    if (!response.data || !response.data.success) return false;
    await updateUsers({});
    await updateCourse();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonText={messages.commonRemoveAll}
      category="danger"
      confirmText={messages.settingsRemoveAllUsersConfirm}
      confirmTitle={messages.settingsRemoveAllUsers}
      onConfirm={remove}
      successMessage={messages.settingsRemoveAllUsersSuccess}
    />
  );
};

export default ShareUsersRemoveAll;
